// extracted by mini-css-extract-plugin
export default {"detail":"FruitDrug_detail__3GWzL","detail-info":"FruitDrug_detail-info__1ARJY","product-unit":"FruitDrug_product-unit__CoHly","show-more-button":"FruitDrug_show-more-button__MOyMR"};